/* @flow */

import * as React from 'react';

import FAIcon from 'common/components/FAIcon';

export default function AccordionStateIcon(props: { isOpen: boolean }) {
  const chevronIcon = `chevron-${props.isOpen ? 'up' : 'down'}`;
  return <FAIcon name={chevronIcon} />;
}
